import React from "react";
import CommunityAddPage from "../community/components/CommunityAddPage";
import { OTHER_REQUESTS } from "../community/constants";

export default function AddOtherRequestsPage() {
  return <CommunityAddPage section={OTHER_REQUESTS} />;
}
